<p-card header="Cargar fichero CSV" styleClass="p-card-content-no-padding">
    <div class="grid mt-4">
        <div class="input-field col-3">
            <label for="companyId">Compañia</label>
            <p-dropdown name="companyId" [options]="companies" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" placeholder="Seleccione compañia" appendTo="body"
                (onChange)="onCompanySelect($event.value)" 
                [(ngModel)]="invoice.thirdPartyId" d-form-field-error />
        </div> 
        <div class="input-field col-3">
            <label for="contractId">Contrato</label>
            <p-dropdown name="contractId" [options]="contracts" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" placeholder="Seleccione contrato" appendTo="body"
                (onChange)="onContractSelect($event.value)" 
                [(ngModel)]="invoice.contractId" d-form-field-error>
                <ng-template pTemplate="selectedItem">
                    <span *ngIf="contract">{{contract?.name}} ({{contract?.business?.name}})</span>
                </ng-template>
                <ng-template let-contract pTemplate="item">
                    {{contract.name}} ({{contract.business?.name}})
                </ng-template>
            </p-dropdown>
        </div> 
        <div class="input-field col-2">
            <label for="file">&nbsp;</label>
            <p-fileUpload mode="basic" chooseIcon="pi pi-upload" chooseLabel="Seleccionar CSV" (onSelect)="onFileSelect($event)" />
        </div>
        <div class="input-field col-4">
            <label>&nbsp;</label>
            <div class="flex gap-2 justify-content-end">
                <button pButton *ngIf="this.file!=null" label="Validar CSV" icon="pi pi-check" (click)="parseCSV()"></button>
                <button pButton *ngIf="this.file!=null && this.step=='generate'" label="Exportar excel" icon="pi pi-file-excel" (click)="exportXLSX()"></button>
            </div>
        </div>
    </div>
    <div *ngIf="this.step=='generate' && this.file!=null">
        <p-messages severity="error" [closable]="false" *ngIf="csvErrors>0" >
            <ng-template pTemplate>
                Se han encontrado {{ csvErrors }} errores, por favor resuélvalos antes de generar la factura.
            </ng-template>
        </p-messages>
        <p-table [value]="parseResults" [paginator]="true" [rows]="10" [responsiveLayout]="'scroll'">
            <ng-template pTemplate="header">
                <tr>
                    <th>Nº servicio</th>
                    <th>Fecha factura</th>
                    <th>Número factura</th>
                    <th>Neto</th>
                    <th>Total</th>
                    <th>Estado pago</th>
                    <th>Fecha pago</th>
                    <th>Importable</th>
                    <th>Dif.</th>             
                    <th>Información</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr [ngClass]="{'bg-red-100': !data.importable, 'bg-yellow-100': data.importable && data.info!=''}">
                    <td>{{ data.caseNotificationNumberCode }}</td>
                    <td>{{ data.invoiceDate | date:'dd/MM/yyyy' }}</td>
                    <td>{{ data.invoiceNumber }}</td>
                    <td>{{ data.invoiceSubtotal | currency:'EUR':'symbol':'1.2-2' }}</td>
                    <td>{{ data.invoiceTotal | currency:'EUR':'symbol':'1.2-2' }}</td>
                    <td>{{ data.isPayed ? 'Sí' : 'No' }}</td>
                    <td>{{ data.paymentDate ? (data.paymentDate | date:'dd/MM/yyyy') : '' }}</td>
                    <td><i class="pi" [ngClass]="{'pi-check-circle text-green-500': data.importable, 'pi-times-circle text-red-500': !data.importable}"></i></td>       
                    <td><span *ngIf="data.diff!=null && data.diff!=0">{{ data.diff | currency:'EUR':'symbol':'1.2-2' }}</span></td>   
                    <td>{{ data.info }}</td>                
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>

<p-card styleClass="mt-4" header="Generar factura" *ngIf="this.step=='generate'">
    <div class="grid">
        <div class="input-field mt-2 col-4">
            <label for="name">Serie</label>
            <p-dropdown name="transactionSerieId" [options]="transactionSeries" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" placeholder="Seleccione serie" appendTo="body"          
                [(ngModel)]="invoice.transactionSerieId" d-form-field-error/>
        </div> 
        <div class="input-field mt-2 col-4" *ngIf="invoice.transactionSerieId == -1">
            <label for="code">Código</label>
            <input pInputText placeholder="Ingrese código manualmente" [(ngModel)]="invoice.code" name="code"
                class="w-full" />
        </div> 
        <div class="input-field mt-2 col-4">        
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="invoice.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error (ngModelChange)="onInvoiceDateChange($event)" 
                appendTo="body"></p-calendar>
        </div> 
    </div>
    <div class="grid" *ngIf="this.step=='generate'">
        <div class="input-field mt-2 col-3">
            <label for="paymentMethodId">Forma de pago</label>
            <p-dropdown name="paymentMethodId" [options]="paymentsMethods" optionLabel="name" optionValue="id"
                [filter]="true" filterBy="name" placeholder="Seleccione forma de pago" appendTo="body"
                (onChange)="onPaymentMethodChange($event.value)" 
                [(ngModel)]="invoice.paymentMethodId" d-form-field-error />
        </div> 
        <div class="input-field mt-2 col-6" *ngIf="selectedPaymentMethodRequiresBank">
            <label for="billingCompanyBankAccountId">Cuenta bancaria</label>
            <p-dropdown name="billingCompanyBankAccountId" [options]="billingCompaniesBanksAccounts"
                optionLabel="accountNumber" optionValue="id" [filter]="true" filterBy="accountNumber" [(ngModel)]="invoice.billingCompanyBankAccountId"
                placeholder="Seleccione cuenta bancaria" appendTo="body" 
                d-form-field-error />
        </div>
        <div class="input-field mt-2 col-3">
            <label for="date">Fecha de vencimiento</label>
            <p-calendar [firstDayOfWeek]="1" [(ngModel)]="invoice.paymentDuedate" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                [yearNavigator]="true" dateFormat="dd/mm/yy"  d-form-field-error appendTo="body"></p-calendar>
        </div>
    </div>

    <div class="pt-3 flex flex-column align-items-end" style="font-size: 14px;" *ngIf="this.file!=null">
        <div><b>Importe neto: {{ subtotalTransactions | currency:'EUR':'symbol':'1.2-2' }}</b></div>
        <div><b>Importe IVA: {{ subtotalTaxAmount | currency:'EUR':'symbol':'1.2-2' }}</b></div>
        <div><b>Importe total: {{ totalTransactions | currency:'EUR':'symbol':'1.2-2' }}</b></div>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
        <button pButton *ngIf="step=='generate'" label="Generar factura" icon="pi pi-check" [disabled]="subtotalTransactions<=0 || csvErrors>0" (click)="generateInvoice()"></button>
    </div>
</p-card>
